import {
  type TemplateVariable,
  TemplateVariableType,
} from "@/shared/domain/agents";

/**
 * The values a launch opens on: the URL's `?dataset_id` on every
 * DATASET_ID-typed variable, and nothing else. Declared defaults are not
 * copied: an untouched variable is absent from the request and the server
 * substitutes its default.
 *
 * @param datasetIdFromUrl The URL's dataset id, or `""` for none.
 */
export function seedLaunchValues(
  variables: readonly TemplateVariable[],
  datasetIdFromUrl: string,
): Record<string, string> {
  if (datasetIdFromUrl === "") {
    return {};
  }
  return Object.fromEntries(
    variables
      .filter((variable) => variable.type === TemplateVariableType.DATASET_ID)
      .map((variable) => [variable.name, datasetIdFromUrl]),
  );
}
